import { render, staticRenderFns } from "./EDocuments.vue?vue&type=template&id=427a77a7&"
import script from "./EDocuments.vue?vue&type=script&lang=js&"
export * from "./EDocuments.vue?vue&type=script&lang=js&"
import style0 from "./EDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports